import Base from './Base'
import Home from './Home'
import About from './About'
import Detail from './Detail'
import Contact from './Contact'
import Legals from './Legals'
import ProductsPage from './ProductsPage'
import Combos from './Combos'
import Empresas from './Empresas'
import Productores from './Productores'
import Blog from './Blog'
import Single from './Single'
import Legales from './Legales'
import Individuos from './Individuos'
import Proposito from './Proposito'
import SingleProposito from './SingleProposito'
import SeParte from './SeParte'
import Category from './Category'

export {
    Base,
    Home,
    Contact,
    Legals,
    ProductsPage,
    Combos,
    Empresas,
    Productores,
    Blog,
    Single,
    Legales,
    Individuos,
    Proposito,
    SingleProposito,
    SeParte,
    Category
}